import React from "react"
import PropTypes from "prop-types"
import { semantic } from '@lexody/design-tokens'


class LexicoinItem  extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div
        style={{
          backgroundColor: semantic.premium.surface.lighter,
          width: 160,
          height: 120,
          borderRadius: 10,
          cursor: 'pointer'
        }}
        onClick={this.props.onClick}>
        <h4 style={{marginBottom: 5, marginTop: 5, color: semantic.greyscale.text.negative, fontWeight: 'bold'}}>{this.props.title}</h4>
        <div className={this.props.imageName}></div>
        <p style={{marginTop: 8, color: semantic.greyscale.text.negative, textAlign: 'right', marginRight: 8}}>{this.props.price}</p>
      </div>
    )
  }
}

export default LexicoinItem
